export default __webpack_public_path__ + "static/media/support-squad-header.08c182c3.jpg";